<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <div class="text-left">
      <h2>Questionnaires de collecte de données client</h2>
    </div>

    <hr>

      <app-alert-messages [contexts]="[alertContextEnum.ClientQuestionnaireDeleted]"></app-alert-messages>

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">

                  <!-- Title -->
                  <h4 class="card-header-title">
                    Questionnaires de collecte de données client
                  </h4>

                </div>
                <div class="col-auto">
                  @if (this.isLoading) {
                    <span class="text-muted me-3"><i class="fas fa-sync fa-spin"></i> Actualisation en cours</span>
                  }
                  @if (this.showHasBeenRefreshed) {
                    <span class="text-muted me-3">Actualisé</span>
                  }

                  <a (click)="refresh(); $event.preventDefault()" class="btn btn-link" href="">
                    Actualiser
                  </a>

                  <!-- Button -->
                  <a aria-expanded="false" aria-haspopup="true" class="btn btn-primary btn-sm" href="#"
                    role="button" routerLink="create">
                    Nouveau questionnaire
                  </a>

                </div>
              </div> <!-- / .row -->
            </div>

            <app-client-questionnaire-list-table></app-client-questionnaire-list-table>
          </div>

        </div>
      </div> <!-- / .row -->

    </div>
  </div> <!-- / .row -->